{
  "version": 1,
  "asset_id": "8fa52c88-d4e4-4e15-a727-5c53afb97b95",
  "project_id": "5ebebed5-d757-4c4f-9e26-a06d6761c2a0",
  "url": "/__l5e/assets-v1/8fa52c88-d4e4-4e15-a727-5c53afb97b95/offergeld.png",
  "r2_key": "a/v1/5ebebed5-d757-4c4f-9e26-a06d6761c2a0/8fa52c88-d4e4-4e15-a727-5c53afb97b95/offergeld.png",
  "original_filename": "offergeld.png",
  "size": 39158,
  "content_type": "image/png",
  "created_at": "2026-06-25T00:53:49Z"
}
